import React, { useState } from 'react';

interface CollectionItemsProps {
    item: any;
    onClick?: (item: any) => void;
    onDelete: (id: any) => void
}

const CollectionItems: React.FC<CollectionItemsProps> = ({
    item,
    onClick,
    onDelete
}) => {
    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    const handleMenuToggle = (
        e: React.MouseEvent<HTMLButtonElement>,
        id: number
    ) => {
        e.stopPropagation();
        setOpenMenuId(prev => (prev === id ? null : id));
    };

    const handleMenuAction = (
        e: any
    ) => {
        if (openMenuId) onDelete(item?.id)
        e.stopPropagation();
        setOpenMenuId(null);
    };

    return (
        <div
            className="collection-card"
            onClick={(e) => {
                if (openMenuId) {
                    e.stopPropagation();
                    setOpenMenuId(null);
                    return
                }
                onClick?.(item)
            }}
        >
            <div className="collection-card__image-wrapper">
                <img
                    src={item?.thumbnail || '/assets/images/yellow-6th.png'}
                    alt={item?.name || 'Collection'}
                    className="collection-card__image"
                />
            </div>

            <div className="collection-card__content">
                <div className="collection-card__info">
                    <h3 className="collection-card__title">
                        {item?.name}
                    </h3>

                    <p className="collection-card__subtitle">
                        {`${item?.location_count || 0} ${item?.location_count > 1 ? 'Locations' : 'Location'}`}
                    </p>
                </div>

                <div
                    className="collection-card__menu"
                    onClick={e => e.stopPropagation()}
                >
                    <button
                        type="button"
                        className="collection-card__menu-button"
                        aria-label="More options"
                        onClick={e =>
                            handleMenuToggle(e, item?.id)
                        }
                    >
                        <img
                            src="/assets/images/dots-horizontal-rounded.svg"
                            alt=""
                        />
                    </button>

                    {openMenuId === item?.id && (
                        <div className="collection-card__dropdown">
                            {/* <button
                                type="button"
                                className="collection-card__dropdown-item"
                                onClick={handleMenuAction}
                            >
                                <img
                                    src="/assets/images/plus-icon-1.svg"
                                    alt=""
                                />
                                <span>Assign Location</span>
                            </button>

                            <button
                                type="button"
                                className="collection-card__dropdown-item"
                                onClick={handleMenuAction}
                            >
                                <img
                                    src="/assets/images/share-blue.svg"
                                    alt=""
                                />
                                <span>Share</span>
                            </button> */}

                            <button
                                type="button"
                                className="collection-card__dropdown-item collection-card__dropdown-item--danger"
                                onClick={handleMenuAction}
                            >
                                <img
                                    src="/assets/images/Delete-icon-red.svg"
                                    alt=""
                                />
                                <span>Delete</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CollectionItems;